import {depositGifts, depositSavings} from "./setup";

export default function deposit(props) {
    return {
        name: "deposit",
        title: 'Source of deposit',
        link: `apply/deposit`,
        props: props,
        questions: [
            depositGifts(props),
            depositSavings(props)
        ]
    }
}